<template>
  <div class="wrapper">

    <MenuView />

    <div class="content-wrapper">
      <router-view />
    </div>

    <!-- Main Footer -->
    <footer class="main-footer">
      <!-- To the right -->
      <div class="float-right d-none d-sm-inline">
        <strong>Copyright &copy; 2018-2026 </strong> | All rights reserved. v{{ GLOBAL.VERSION }}
      </div>
      <!-- Default to the left -->
      <div>
        <img src="dist/img/kubber-logo-transparente.png" style="height: 30px; opacity: 0.5;" />
      </div>

    </footer>
  </div>
</template>

<script>
import GLOBAL from './Global.js'
import MenuView from './components/Menu.vue';

export default {
  name: "Dashboard",
  components: {
    MenuView,
  },
  data() {
    return {
      GLOBAL,
      login: false
    }
  }

};
</script>
